import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";

import { ApiService } from 'src/app/api.service';
@Component({
  selector: 'app-onde-encontrar-lojista',
  templateUrl: './onde-encontrar-lojista.component.html',
  styleUrls: ['./onde-encontrar-lojista.component.scss']
})
export class OndeEncontrarLojistaComponent implements OnInit {
  pageType = '';
  isSubmitted = false;
  loading = false;
  finalColumns = 0;
  listStates: any = [];
  ondeEncontrarForm:any;
  stateSelected:any = '';
  listCities: any;
  listNeighborhoods:any = [];
  citySelected: any = 'ALL';
  neighborhoodSelected: any = 'ALL';
  allResellers:any = [];
  filteredResellers:any = [];
  resellersGold:any = [];
  resellers:any = [];

  stateSelectedName = "";

  titlePage = '';

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.titlePage = "Lojistas e Revendedores";

    this.getStates();
  }

  async getStates(){
    await this.apiService.loadEstadosCidades().subscribe(res => {
      this.listStates = res;
      this.loadResellers();
    });
  }

  loadResellers() {
    return this.apiService.loadResellers().subscribe((data) => {
      this.allResellers = this.formatEmail(data);
      this.filterStates();
      if(this.stateSelected && this.citySelected)
        this.allResellers = this.filterResellers(data, this.stateSelected, this.citySelected,this.neighborhoodSelected);

      this.resellers = this.allResellers.filter((reseller:any) => reseller.ouro == "N");
      this.resellersGold = this.allResellers.filter((reseller:any) => reseller.ouro == "S");
    });
  }

  filterResellers(listResellers:any ,state:string, city:string, neighborhood:string){
    city = city.toUpperCase();
    neighborhood = neighborhood.toUpperCase();
    this.stateSelectedName = this.listStates.filter((s:any) => s.sigla == state)[0].nome;

    if(city == "ALL")
      return listResellers.filter((reseller:any) => reseller.sigUfs == state);
    if(neighborhood == "ALL")
      return listResellers.filter((reseller:any) => reseller.sigUfs == state && this.removeAccents(reseller.cidCli.toUpperCase()) == this.removeAccents(city));
    return listResellers.filter((reseller:any) => reseller.sigUfs == state
      &&
      this.removeAccents(reseller.cidCli.toUpperCase()) == this.removeAccents(city)
      &&
      this.removeAccents(reseller.baiCli) == this.removeAccents(neighborhood));
  }

  initializeFormGroup(){
    this.ondeEncontrarForm = this.fb.group({
      bairro: ['ALL'],
      cidade: ['ALL'],
      estado: ['', Validators.required,],
    });
    this.ondeEncontrarForm.get('estado')?.valueChanges.subscribe((state:any) => {
      this.stateSelected = state;
      if(state){
        this.filterCities(state);
      }else {
        this.listCities = [];
      }
      this.citySelected = 'ALL';
      this.ondeEncontrarForm.controls['cidade'].patchValue('ALL');
    });
    this.ondeEncontrarForm.get('cidade')?.valueChanges.subscribe((city:any) => {
      this.citySelected = city;
      if(city !== "ALL"){
        this.filterNeighborhoods(this.stateSelected,city)
      }else {
        this.listNeighborhoods = [];
        this.neighborhoodSelected = 'ALL';
      }
      this.ondeEncontrarForm.controls['bairro'].patchValue('ALL')


    });
    this.ondeEncontrarForm.get('bairro')?.valueChanges.subscribe((neighborhood:any) => {
      this.neighborhoodSelected = neighborhood;
    });

  }


 formatEmail(list:any[]){
  return list.map(obj => {
    if (obj.hasOwnProperty('emaCom') && typeof obj.emaCom === 'string' && obj.emaCom.includes(';')) {
        const emails = obj.emaCom.split(';');
        obj.emaCom = emails[0];
    }
    return obj;
  });
 }

  filterStates(){
    let listStatesWithReseller = this.allResellers.map((reseller:any) => reseller.sigUfs);
    this.listStates = this.listStates.filter((state:any) => listStatesWithReseller.includes(state.sigla));
    this.initializeFormGroup();
  }

  filterCities(state: string) {
    this.listCities = this.listStates.filter((s:any) => s.sigla == state)[0].cidades;
    let listCitiesWithReseller = this.allResellers.filter((reseller:any) => reseller.sigUfs == state);
    listCitiesWithReseller = listCitiesWithReseller.map((reseller:any) => reseller.cidCli);
    this.listCities = this.listCities.filter((city:any) =>
      listCitiesWithReseller.some((cidadeReseller: any) =>
        this.removeAccents(cidadeReseller.toUpperCase()) === this.removeAccents(city.toUpperCase())
      )
    );
    this.citySelected = 'ALL';
  }

  filterNeighborhoods(state:string, city: string){
    city = city.toUpperCase();

    let listFiltered = this.allResellers.filter((reseller: any) =>
      reseller.sigUfs == state &&
      this.removeAccents(reseller.cidCli.toUpperCase()) === this.removeAccents(city.toUpperCase())
    );
    let listNeighborhoodsWithReseller = listFiltered.map((reseller: any) => reseller.baiCli);

    listNeighborhoodsWithReseller = listNeighborhoodsWithReseller.map((neighborhood: any) => this.capitalizeFirstLetters(neighborhood));
    let uniqueNeighborhoodsSet = new Set(listNeighborhoodsWithReseller);

    let uniqueNeighborhoods = Array.from(uniqueNeighborhoodsSet);

    uniqueNeighborhoods = uniqueNeighborhoods.sort((a: any, b: any) => a.localeCompare(b));
    uniqueNeighborhoods.forEach((bairro:any, i) =>{
      if(this.possuiAcento(bairro)){
        let bairroSemAcento = this.removeAccents(bairro);
        let indexToRemove = uniqueNeighborhoods.findIndex((b:any) =>
          this.removeAccents(b.toLowerCase()) === bairroSemAcento.toLowerCase()
        );

        if (indexToRemove !== -1) {
            uniqueNeighborhoods.splice(indexToRemove, 1);
        }
      }
    })
    this.listNeighborhoods = uniqueNeighborhoods;
  }

  capitalizeFirstLetters(input: string) {
    return input.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
  }
  possuiAcento(str:string) {
    const regexAcentos = /[À-ú]/;
    return regexAcentos.test(str);
}

  onSubmit(): void {
    this.isSubmitted = true;
    this.loading = true;
    if(this.isSubmitted){
      let subscripiton = this.loadResellers();
      subscripiton.add(()=>{
        this.isSubmitted = true
        this.loading = false;
      });
    }
  }

  returnToSearch(){
    this.isSubmitted = false;
    this.ondeEncontrarForm.get('estado').value = this.stateSelected;
    if(this.citySelected)
    this.ondeEncontrarForm.get('cidade').value = this.citySelected;
    if(this.neighborhoodSelected)
    this.ondeEncontrarForm.get('bairro').value = this.neighborhoodSelected;
  }

  removeAccents(str:string) {
    return str.normalize("NFD").replace(/[\u0300-\u036F]/g, "");
}

}
